import create from 'zustand'
import { AnatomyEye } from '../../types/graphql'

type AnatomyEyeFormValues = {
  data: AnatomyEye
  isEditing: boolean
}

type AnatomyEyeFormActions = {
  setData: (data: AnatomyEye) => void
  reset: () => void
  setIsEditing: (isEditing: boolean) => void
}

export type AnatomyEyeFormState = AnatomyEyeFormValues & AnatomyEyeFormActions

const initialState: AnatomyEyeFormValues = {
  isEditing: false,
  data: {
    id: '',
    internalAnnotations: '',
    name: '',
    slug: '',
    enable: true,
    thumb: '',
    timestamp: {},
    cacheKey: ''
  }
}

export const useAnatomyEyeForm = create<AnatomyEyeFormState>(set => ({
  ...initialState,
  setData: data => set(state => ({ ...state, data })),
  reset: () => set({ ...initialState }),
  setIsEditing: isEditing => set(state => ({ ...state, isEditing }))
}))
